import useBackBtn from '@/src/hooks/useBackBtn'
import { RefObject } from 'react'

type MicrogamingFrameType = {
  url: string
  className: string
  iframeRef: RefObject<HTMLIFrameElement | null>
}

const MicrogamingFrame = ({
  url,
  className,
  iframeRef,
}: MicrogamingFrameType) => {
  const frameRedirected = useBackBtn()

  return (
    <iframe
      data-testid='game-iframe'
      ref={iframeRef}
      src={url}
      className={className}
      scrolling='no'
      onLoad={frameRedirected}
    />
  )
}

export default MicrogamingFrame
